import { useEffect, useRef, useState } from 'react';
import { useBillingStore } from '@/stores/billingStore';
import { cn } from '@/utils/cn';

function formatNumber(num: number): string {
  return num.toLocaleString('zh-CN');
}

export function PointBalance({ className }: { className?: string }) {
  const balance = useBillingStore((s) => s.balance);
  const fetchBalance = useBillingStore((s) => s.fetchBalance);
  const [displayBalance, setDisplayBalance] = useState(balance);
  const [isAnimating, setIsAnimating] = useState(false);
  const prevBalanceRef = useRef(balance);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  useEffect(() => {
    if (balance !== prevBalanceRef.current) {
      setIsAnimating(true);
      const start = prevBalanceRef.current;
      const end = balance;
      const duration = 500;
      const startTime = performance.now();

      const animate = (now: number) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(start + (end - start) * easeProgress);
        setDisplayBalance(current);
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setDisplayBalance(end);
          setTimeout(() => setIsAnimating(false), 200);
        }
      };

      requestAnimationFrame(animate);
      prevBalanceRef.current = balance;
    }
  }, [balance]);

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-sm font-medium text-success transition-transform duration-200',
        isAnimating && 'scale-110',
        className
      )}
    >
      <span>💰</span>
      <span>{formatNumber(displayBalance)}</span>
    </span>
  );
}
